<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header ref="header" slot="header" @query="getData" />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  components: { PageHeader, PageMain },
  mixins: [BaseTable, EditLoading],
  props: {},
  data() {
    return { usePage: true }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData(form) {
      this.loading = true
      this.$api
        .shipmentDetailQueryFactoryListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
